/* eslint-disable import/no-cycle */
import Register from '../views/register/Register.vue';
import Parent from '../views/Parent.vue';

// import client aggregator
import Aggregator from '../views/client/aggregator/Aggregator.vue';
import AggregatorDetail from '../views/client/aggregator/AggregatorDetail.vue';
import SubMerchant from '../views/client/aggregator/SubMerchant.vue';

// import client merchant
import Merchant from '../views/client/merchant/Merchant.vue';
import MerchantDetail from '../views/client/merchant/MerchantDetail.vue';
import MerchantOutlet from '../views/client/merchant/MerchantOutlet.vue';

import { setBreadcrumb } from './index';

const clientRoute = {
  path: '/client',
  name: 'Client',
  meta: {
    title: 'BNI QRIS - Client',
    appBarTitle: 'Client',
  },
  component: Parent,
  children: [
    {
      path: '/client/merchant',
      meta: {
        title: 'BNI QRIS - Merchant',
        appBarTitle: 'Merchant',
        breadcrumbs: () => [
          setBreadcrumb('client', '/client', true),
          setBreadcrumb('merchant', '/client/merchant'),
        ],
      },
      component: Merchant,
      name: 'Merchant',
    },
    {
      path: '/client/merchant/view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Merchant Detail',
        appBarTitle: 'Merchant Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('client', '/client', true),
            setBreadcrumb('merchant', '/client/merchant'),
            setBreadcrumb('detail', '/client/merchant/view', true),
            setBreadcrumb(`${id}`, `/client/merchant/view/${id}`),
          ];
        },
      },
      component: MerchantDetail,
      name: 'MerchantDetail',
    },
    {
      path: '/client/aggregator',
      meta: {
        title: 'BNI QRIS - Aggregator',
        appBarTitle: 'Aggregator',
        breadcrumbs: () => [
          setBreadcrumb('client', '/client', true),
          setBreadcrumb('aggregator', '/client/aggregator'),
        ],
      },
      component: Aggregator,
      name: 'Aggregator',
    },
    {
      path: '/client/merchant/register',
      name: 'RegisterMerchant',
      meta: {
        title: 'BNI QRIS - Register Merchant',
        appBarTitle: 'Register Merchant',
        breadcrumbs: () => [
          setBreadcrumb('inputer', '/inputer', true),
          setBreadcrumb('merchant', '/inputer/merchant'),
          setBreadcrumb('register', '/client/merchant/register', true),
        ],
      },
      component: Register,
    },
    {
      path: '/client/aggregator/view/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Aggregator Detail',
        appBarTitle: 'Aggregator Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('client', '/client', true),
            setBreadcrumb('aggregator', '/client/aggregator'),
            setBreadcrumb('detail', '/client/aggregator/view', true),
            setBreadcrumb(`${id}`, `/client/aggregator/view/${id}`),
          ];
        },
      },
      component: AggregatorDetail,
      name: 'AggregatorDetail',
    },
    {
      path: '/client/aggregator/:id(\\d+)/sub-merchant',
      name: 'SubMerchant',
      meta: {
        title: 'BNI QRIS - Sub Merchant',
        appBarTitle: 'Sub Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('client', '/client', true),
            setBreadcrumb('aggregator', '/client/aggregator'),
            setBreadcrumb(`${id}`, `/client/aggregator/${id}`, true),
            setBreadcrumb(
              'list sub merchant',
              `/client/aggregator/${id}/sub-merchant`
            ),
          ];
        },
      },
      component: SubMerchant,
    },
    {
      path: '/client/sub-merchant',
      name: 'AllSubMerchant',
      meta: {
        title: 'BNI QRIS - Sub Merchant',
        appBarTitle: 'Sub Merchant',
        breadcrumbs: () => [
          setBreadcrumb('client', '/client', true),
          setBreadcrumb('sub merchant', '/client/sub-merchant'),
        ],
      },
      component: SubMerchant,
    },
    {
      path: '/client/sub-merchant/:id(\\d+)/list-outlet',
      name: 'AllSubMerchantOutlet',
      meta: {
        title: 'BNI QRIS - Sub Merchant Outlet',
        appBarTitle: 'Sub Merchant Outlet',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('client', '/client', true),
            setBreadcrumb('sub merchant', '/client/sub-merchant'),
            setBreadcrumb(`${id}`, `/client/sub-merchant/${id}`, true),
            setBreadcrumb(
              'list outlet',
              `/client/sub-merchant/${id}/list-outlet`
            ),
          ];
        },
      },
      component: MerchantOutlet,
    },
    {
      path: '/client/aggregator/:idAggregator(\\d+)/sub-merchant/:id(\\d+)/list-outlet',
      name: 'SubMerchantOutlet',
      meta: {
        title: 'BNI QRIS - Sub Merchant Outlet',
        appBarTitle: 'Sub Merchant Outlet',
        breadcrumbs: (params) => {
          const { idAggregator } = params;
          const { id } = params;
          return [
            setBreadcrumb('client', '/client', true),
            setBreadcrumb('aggregator', '/client/aggregator'),
            setBreadcrumb(
              `${idAggregator}`,
              `/client/aggregator/${idAggregator}`,
              true
            ),
            setBreadcrumb(
              'list sub merchant',
              `/client/aggregator/${idAggregator}/sub-merchant`
            ),
            setBreadcrumb(
              `${id}`,
              `/client/aggregator/${idAggregator}/sub-merchant/${id}`,
              true
            ),
            setBreadcrumb(
              'list outlet',
              `/client/aggregator/${idAggregator}/sub-merchant/${id}/list-outlet`
            ),
          ];
        },
      },
      component: MerchantOutlet,
    },
    {
      path: '/client/merchant/:id(\\d+)/list-outlet',
      name: 'ListOutletMerchant',
      meta: {
        title: 'BNI QRIS - List Outlet Merchant',
        appBarTitle: 'List Outlet Merchant',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('client', '/client', true),
            setBreadcrumb('merchant', '/client/merchant'),
            setBreadcrumb(`${id}`, `/client/merchant/${id}`, true),
            setBreadcrumb('list outlet', `/client/merchant/${id}/list-outlet`),
          ];
        },
      },
      component: MerchantOutlet,
    },
  ],
};

export default clientRoute;
